import buffer from "@turf/buffer";
import convex from "@turf/convex";
import { SelectionGeometry } from "../../../../js/stores/map/store";

export const addBufferToGeometry = (geometry: SelectionGeometry, bufferInMeters = 50) => {
  const convexedData = convex(geometry);

  if (!convexedData) {
    return null;
  }

  return buffer(convexedData, bufferInMeters, { units: "meters" });
};
